import getCache from '../../cache/helpers/getCache';

export default () => {
  const notificationsCache = getCache('notifications');
  const modalsByIdCache = getCache('notificationsModalsById');
  const { modals } = notificationsCache.data;
  const modal = modals[modals.length - 1];

  if (modal) {
    modal.commitAction({ type: 'CLOSE', payload: modalsByIdCache.data[modal.id] });
  }
};
